import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-redirect-rock',
    templateUrl: './redirect-rock.component.html',
    styleUrls: ['./redirect-rock.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RedirectRockComponent {
  constructor() {}
}
